var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import * as Constant from '../../../utils/Constant';
import MetricSelect from './metric-select';
import ChipWrapper from './chip-wrapper';
import { metricsGA, metricNonDimensionByGA } from '../../../utils/ReportUtil';
import './chip-metrics.scss';
var ChipMetrics = function (props) {
    var t = useTranslation().t;
    var publishers = props.publishers, onChangeMetric = props.onChangeMetric, data = props.data, metrics = props.metrics, showMetrics = props.showMetrics, metricSelectedList = props.metricSelectedList;
    var _a = useState([]), publisherList = _a[0], setPublisherList = _a[1];
    var _b = useState(), metricCategory = _b[0], setMetricCategory = _b[1];
    var _c = useState([]), metricDimensionSelected = _c[0], setMetricDimensionSelected = _c[1];
    var _d = useState([]), metricSelected = _d[0], setMetricSelected = _d[1];
    useEffect(function () {
        setPublisherList(publishers);
    }, [publishers]);
    useEffect(function () {
        var normalMetrics = metricSelectedList === null || metricSelectedList === void 0 ? void 0 : metricSelectedList.filter(function (metric) { return metric && !metric.dimensionAble; });
        var dimensionMetrics = metricSelectedList === null || metricSelectedList === void 0 ? void 0 : metricSelectedList.filter(function (metric) { return metric && metric.dimensionAble; });
        setMetricSelected((normalMetrics || []).concat(dimensionMetrics || []));
    }, [metricSelectedList]);
    useEffect(function () {
        buildMetricCategory();
    }, [metrics]);
    var buildMetricCategory = function () {
        var categories = {};
        categories[Constant.METRIC_DEFAULT] = [];
        categories[Constant.METRIC_DATE_AND_SALE] = [];
        categories[Constant.METRIC_DATA_LAYER] = [];
        categories[Constant.METRIC_ADVERTISEMENT] = [];
        categories[Constant.METRIC_ANALYTIC] = [];
        categories[Constant.METRIC_VIDEO_VIEW] = [];
        categories[Constant.METRIC_TREND] = [];
        if (metrics) {
            var foundMetricByGA_1 = (metrics || []).find(function (metric) {
                if (metric.selected) {
                    var foundMetricGA = metricsGA.find(function (metricGA) { return metricGA === metric.defaultCollectionField; });
                    return foundMetricGA ? true : false;
                }
                else {
                    return false;
                }
            });
            var foundMetricNonByGA_1 = (metrics || []).find(function (metric) {
                if (metric.selected) {
                    var foundMetricNonGA = metricNonDimensionByGA.find(function (metricNonGA) { return metricNonGA === metric.defaultCollectionField; });
                    return foundMetricNonGA ? true : false;
                }
                else {
                    return false;
                }
            });
            metrics.forEach(function (metric) {
                metric.isLogicGA = false;
                if (foundMetricByGA_1) {
                    var foundMetricByNonGA = metricNonDimensionByGA.find(function (metricNonGA) { return metricNonGA === metric.defaultCollectionField; });
                    if (foundMetricByNonGA)
                        metric.isLogicGA = true;
                }
                else if (foundMetricNonByGA_1) {
                    var foundMetricByGA_2 = metricsGA.find(function (metricGA) { return metricGA === metric.defaultCollectionField; });
                    if (foundMetricByGA_2)
                        metric.isLogicGA = true;
                }
                switch (metric.purpose) {
                    case Constant.METRIC_DEFAULT:
                        categories[Constant.METRIC_DEFAULT].push(metric);
                        break;
                    case Constant.METRIC_DATE_AND_SALE:
                        categories[Constant.METRIC_DATE_AND_SALE].push(metric);
                        break;
                    case Constant.METRIC_DATA_LAYER:
                        categories[Constant.METRIC_DATA_LAYER].push(metric);
                        break;
                    case Constant.METRIC_ADVERTISEMENT:
                        categories[Constant.METRIC_ADVERTISEMENT].push(metric);
                        break;
                    case Constant.METRIC_ANALYTIC:
                        categories[Constant.METRIC_ANALYTIC].push(metric);
                        break;
                    case Constant.METRIC_VIDEO_VIEW:
                        categories[Constant.METRIC_VIDEO_VIEW].push(metric);
                        break;
                    case Constant.METRIC_TREND:
                        categories[Constant.METRIC_TREND].push(metric);
                        break;
                    default:
                        categories[Constant.METRIC_DEFAULT].push(metric);
                        break;
                }
            });
        }
        // buildMetricSelectedDefault(categories);
        setMetricCategory(categories);
    };
    var buildMetricSelectedDefault = function (dataCatgories) {
        var metricSelects = [];
        Object.keys(dataCatgories).forEach(function (category) {
            dataCatgories[category].forEach(function (metric) {
                if (metric.selected) {
                    metricSelects.push(metric);
                }
            });
        });
        setMetricSelected(metricSelects);
    };
    var buildMetricSelected = function (dataCatgories, chipItem) {
        var metricSelecteds = metricSelectedList && metricSelectedList.length ? _.clone(metricSelectedList) : [];
        var metricSelected = null;
        Object.keys(dataCatgories).forEach(function (category) {
            dataCatgories[category].forEach(function (metric) {
                if (metric.selected && chipItem.selected && metric.id == chipItem.id) {
                    metricSelected = metric;
                }
            });
        });
        var foundListDimensionMetric = (metricSelecteds || []).filter(function (metricSelectedItem) { return metricSelectedItem.dimensionAble; });
        if (metricSelected) {
            if (metricSelected.dimensionAble && foundListDimensionMetric && foundListDimensionMetric.length) {
                metricSelecteds.splice(foundListDimensionMetric.length, 0, metricSelected);
            }
            else {
                metricSelecteds.push(metricSelected);
            }
        }
        else {
            var foundMetricSelectedIndex = metricSelecteds.findIndex(function (metric) { return metric.id == chipItem.id; });
            if (foundMetricSelectedIndex > -1) {
                metricSelecteds.splice(foundMetricSelectedIndex, 1);
            }
            else {
                if (chipItem.dimensionAble && foundListDimensionMetric && foundListDimensionMetric.length) {
                    metricSelecteds.splice(foundListDimensionMetric.length, 0, chipItem);
                }
                else {
                    metricSelecteds.push(chipItem);
                }
            }
        }
        var normalMetrics = metricSelecteds === null || metricSelecteds === void 0 ? void 0 : metricSelecteds.filter(function (metric) { return metric && !metric.dimensionAble; });
        var dimensionMetrics = metricSelecteds === null || metricSelecteds === void 0 ? void 0 : metricSelecteds.filter(function (metric) { return metric && metric.dimensionAble; });
        setMetricSelected((normalMetrics || []).concat(dimensionMetrics || []));
        onChangeMetric(metricSelecteds);
    };
    var onChangeMetricSelect = function (type, data, chipItem) {
        if (type && chipItem) {
            var foundMetricHanlde = (metricSelectedList || []).find(function (metric) { return metric.defaultCollectionField == chipItem.defaultCollectionField; });
            if (chipItem.selected && foundMetricHanlde)
                return;
            var metricCatgories = __assign({}, metricCategory);
            metricCatgories[type] = data;
            setMetricCategory(metricCatgories);
            buildMetricSelected(metricCatgories, chipItem);
        }
    };
    var onChangeMetricSelected = function (metrics, value) {
        if (value) {
            var metricFilters = metrics.filter(function (metric) { return metric.id != value.id; });
            if (metricFilters && metricFilters.length) {
                var metricCatgories = __assign({}, metricCategory);
                Object.keys(metricCatgories).forEach(function (category) {
                    if (category == value.purpose) {
                        var foundIndex = metricCatgories[category].findIndex(function (metricCategory) { return metricCategory.id == value.id; });
                        if (foundIndex >= 0) {
                            metricCatgories[category][foundIndex].selected = false;
                        }
                    }
                });
                setMetricCategory(metricCatgories);
                setMetricSelected(metricFilters);
                onChangeMetric(metricFilters);
            }
        }
        else {
            setMetricSelected(metrics);
            onChangeMetric(metrics);
        }
    };
    return (React.createElement("div", { className: "chips-container" },
        React.createElement("div", { className: "metric-list-selected" },
            React.createElement(DndProvider, { backend: HTML5Backend },
                React.createElement(ChipWrapper, { data: metricSelected, multiple: true, isAllowDrag: true, onChangeMetric: function (data, value) { if (data)
                        onChangeMetricSelected(data, value); } }))),
        showMetrics ? React.createElement("div", { className: "panel-metric-select" },
            React.createElement(MetricSelect, { categories: metricCategory, onChangeMetricSelect: onChangeMetricSelect })) : null));
};
export default ChipMetrics;
